module.exports = __webpack_public_path__ + "img/info_bottom.f5075b1d.svg";